class UpsellShowMore extends window.BAO.CustomElement {
  connectedCallback () {
    super.connectedCallback()

    this.setInitialHeight()

    // Bind the throttled resize handler using your throttle function
    this.handleResize = this.throttle(this.onResize.bind(this), 200)
    window.addEventListener('resize', this.handleResize)
  }

  disconnectedCallback () {
    super.disconnectedCallback()
    window.removeEventListener('resize', this.handleResize)
  }

  setupListeners () {
    super.setupListeners()

    if (
      this.els.showMore?.exists !== true ||
      this.els.showLess?.exists !== true
    )
      return

    this.els.showMore.element.addEventListener(
      'click',
      this.showMore.bind(this)
    )
    this.els.showLess.element.addEventListener(
      'click',
      this.showLess.bind(this)
    )
  }

  setInitialHeight () {
    // Determine the number of items to show initially (up to 3)
    const initialVisibleItems = Math.min(3, this.els.item.elements.length)
    this.initialHeight = this.calculateHeight(initialVisibleItems)

    // Calculate the height to show all items
    this.expandedHeight = this.calculateHeight(this.els.item.elements.length)

    // Set the container to the appropriate height based on current state
    if (this.isExpanded) {
      this.els.items.element.style.height = `${this.expandedHeight}px`
    } else {
      this.els.items.element.style.height = `${this.initialHeight}px`
    }
  }

  calculateHeight (visibleItemsCount) {
    const items = Array.from(this.els.item.elements).slice(0, visibleItemsCount)

    const totalHeight = items.reduce((height, item) => {
      const itemHeight = item.offsetHeight
      const style = window.getComputedStyle(item)
      const margins =
        parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10)
      return height + itemHeight + margins
    }, 0)

    return totalHeight
  }

  showMore () {
    this.isExpanded = true
    this.els.items.element.style.height = `${this.expandedHeight}px`
    this.els.showMore.element.setAttribute('aria-hidden', 'true')
    this.els.showLess.element.setAttribute('aria-hidden', 'false')
  }

  showLess () {
    this.isExpanded = false
    this.els.items.element.style.height = `${this.initialHeight}px`
    this.els.showMore.element.setAttribute('aria-hidden', 'false')
    this.els.showLess.element.setAttribute('aria-hidden', 'true')
  }

  onResize () {
    // Recalculate heights on window resize
    this.setInitialHeight()
  }

  // Your throttle function without semicolons
  throttle (callback, wait, immediate = false) {
    let timeout = null
    let initialCall = true

    return function (...args) {
      const callNow = immediate && initialCall
      const next = () => {
        callback.apply(this, args)
        timeout = null
      }

      if (callNow) {
        initialCall = false
        next()
      }

      if (!timeout) {
        timeout = window.setTimeout(next, wait)
      }
    }
  }
}

if (!customElements.get('upsell-show-more')) {
  customElements.define('upsell-show-more', UpsellShowMore)
}
